import axios from 'axios';

let brandArt = document.getElementById('brandArticle')
if (brandArt !== null) {
    fetch('/article/brand/' + brandArt.dataset.brand)
        .then((res) => {
            if (res.ok) return res.text();
            else throw new Error("Status code error :" + res.status);
        })
        .then(html => {
            document.querySelector('#brandArticle').insertAdjacentHTML('beforeend', html);
        }).catch(function (err) {
            document.getElementById('brandcontainer').style.display = 'none';
        });
}

document.addEventListener("DOMContentLoaded", () => {

    let relatedArticle = document.getElementById('relatedArticle')

    fetch('/article/related/' + relatedArticle.dataset.tags)
        .then((res) => {
            if (res.ok) return res.json();
            else throw new Error("Status code error :" + res.status);
        }).then(data => {
            relatedArticle.insertAdjacentHTML('beforeend', data.bottom);
        }).catch(function (err) {
            relatedArticle.style.display = 'none';
        });

    let recommendArticle = document.getElementById('recommendArticle')
    fetch('/article/recommended')
        .then((res) => {
            if (res.ok) return res.text();
            else throw new Error("Status code error :" + res.status);
        }).then(data => {
            recommendArticle.insertAdjacentHTML('beforeend', data);
        }).catch(function (err) {
            recommendArticle.style.display = 'none';
        });

    let Videorekomendasi = document.getElementById('videorekomendasi');

    if (typeof (Videorekomendasi) != 'undefined' && Videorekomendasi != null) {

        fetch('/article/recommend-video')
            .then((res) => {
                if (res.ok) return res.text();
                else throw new Error("Status code error :" + res.status);
            }).then(data => {
                recommendArticle.insertAdjacentHTML('beforeend', data);
            }).catch(function (err) {
                console.log(err);
                recommendArticle.style.display = 'none';
            });

    }



    let blmnetwork = document.getElementById('blmnetwork')
    fetch('/article/blm-network')
        .then((res) => {
            if (res.ok) return res.text();
            else throw new Error("Status code error :" + res.status);
        }).then(data => {
            blmnetwork.insertAdjacentHTML('beforeend', data);
        }).catch(function (err) {
            blmnetwork.style.display = 'none';
        });
});

let formPolling = document.querySelector('#polling-form');
if (formPolling !== null) {
    formPolling.addEventListener('submit', function (e) {
        e.preventDefault();
        let form = e.target;
        let url = formPolling.getAttribute('data-url');
        let formData = new FormData(form);
        axios({
            method: 'POST',
            url: url,
            data: formData,
            headers: {
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        }).then(function (response) {
            if (response.data.status == 'success') {
                let pollingCard = document.querySelector('#polling-card');
                let pollingSuccess = document.querySelector('#polling-success');
                // hide the polling
                pollingCard.classList.add('hidden');
                // show the polling success
                pollingSuccess.classList.remove('hidden');
                // remove the polling form
                formPolling.remove();
            }
        })
    });
}
